import { Component, Input, OnInit } from '@angular/core';

import { IWizardContentComponent } from '../../../wizard.content';
import { DatasourceWizardService } from '../../../services/datasource/datasource.wizard.service';

@Component({
  selector: 'datasource.agent.upgrade.result.html',
  templateUrl: './datasource.agent.upgrade.result.page.html',
  providers: [],
  styleUrls: ['./datasource.agent.upgrade.result.scss']
})
export class DatasourceAgentUpgradeResultComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  failureMsg: string;
  successFlag: string;
  successMsg: string;
  agentUpgrade = false;
  successDescription: string;

  constructor(private wizardService: DatasourceWizardService) {}

  ngOnInit() {
    this.generateTextByMode();
  }

  generateTextByMode(): void {
    this.failureMsg = 'Upgrade request failed';
    this.successMsg = 'upgrade request was successfull';
    this.successDescription =
      'You can monitor the status of the upgrade on the Device management page';
  }
  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }

  requestFailed(): boolean {
    return this.wizardCtrl.getWizardService().requestFailed;
  }
}
